import SEO from '../components/SEO/SEO'
import Link from 'next/link'
import ContactForm from '../components/ContactForm/ContactForm'
import Layout from '../layout/Layout'
import classes from '../styles/section.module.css'

const OurStory = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="banner/about-banner.png"
                  alt="Evry Health team and culture"
                />
              </div>
              <div className="relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32">
                <h1 className="text-3xl tracking-tight md:text-5xl text-darkBlue">
                  We&#39;re on a mission
                </h1>
                <p className="max-w-lg mt-6 text-xl text-grey sm:max-w-xl">
                  A mission to bring a personalized, human approach to how we
                  deliver health insurance.
                </p>
                <Link href="/contact-us">
                  <button className="inline-block px-8 py-2 mt-8 text-xl font-bold bg-transparent border-2 text-blue border-blue hover:bg-blue hover:text-white-light">
                    Apply Now
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
            <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div className="lg:col-span-1">
                <div className="flex items-center justify-center">
                  <img
                    className="h-56 mb-10 md:h-96"
                    src="chris-gay-headshot.png"
                    alt="Christopher E. Gay, CEO of Evry Health"
                  />
                </div>
              </div>

              <div className="lg:col-span-1">
                <h2 className="text-3xl tracking-tight lg:text-4xl text-darkBlue">
                  This is <span className="text-green">personal.</span>
                </h2>
                <div className="text-base text-grey">
                  <p className="pt-6">
                    When we say that healthcare should be a solution, not a
                    system, we truly believe it. To us, this is very personal.
                  </p>
                  <p className="pt-6">
                    We have all suffered under the current system. Whether that
                    means experiencing a personal loss due to a misdiagnosis,
                    enduring sleepless nights worrying about unpaid medical
                    bills, facing the momentous battle of trying to get an
                    insurance company to actually pay for something, or
                    something else entirely, the team at Evry Health finds the
                    current state of affairs profoundly unacceptable.{' '}
                  </p>

                  <p className="pt-6">
                    We look forward to serving you and working with you, to do
                    something better.
                  </p>
                  <p className="pt-6">Sincerely,</p>
                  <img
                    src="signature.png"
                    className="h-40"
                    alt="Christopher E. Gay, Chief Executive Officer signature"
                  />
                  <p className="pt-6">
                    Christopher E. Gay, Chief Executive Officer
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white">
          <div className="max-w-screen-xl px-4 py-12 mx-auto mb-8 sm:px-6 lg:px-8 md:mb-16">
            <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div className="mb-8 lg:col-span-1 md:mb-0">
                <h2 className="text-3xl tracking-tight md:pr-16 lg:text-4xl text-blue-dark">
                  We are building a team of like-minded individuals who share
                  our vision of putting{' '}
                  <span className="text-globeGreen">
                    members’ health at the center of everything that we do.
                  </span>
                </h2>

                <Link href="/careers">
                  <button className="inline-block px-4 py-2 mt-8 text-xl font-bold border-2 bg-white-lighter text-blue border-blue hover:bg-blue hover:text-white-light">
                    Join the Team
                  </button>
                </Link>
              </div>
              <div className="lg:col-span-1">
                <div className="flex items-center justify-center h-full">
                  <figure
                    className={`${classes.meetYourNewTeamSectionImageRight}`}
                  >
                    <img
                      src="about1.png"
                      className="img-fluid"
                      alt="Evry Health team collaborating"
                    />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="px-4 py-24 mx-auto max-w-screen-full sm:px-6 lg:px-8">
            <ContactForm />
          </div>
        </section>
      </Layout>
    </>
  )
}

export default OurStory
